var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data),function(component,i){return _c(component.typeHandle,{key:`builder-component-${i}`,tag:"component",attrs:{"data":component}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }